import { PipeTransform, Pipe } from '@angular/core';
import { StringHelper } from '../helpers/string-helper';

@Pipe({
  name: 'or'
})
export class OrPipe implements PipeTransform {
  transform(s: string, or = '-') {
    return StringHelper.isEmpty(s) ? or : s;
  }
}
